<template>
  <svg
    :width="width ?? 33"
    :height="height"
    viewBox="0 0 33 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3939 27.7345L0.165476 0.429189L32.6223 0.429191L16.3939 27.7345Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  width?: number;
}>();

const height = computed(() => (props.width ? props.width * 0.848 : 28));
</script>
